import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/HomePage";
import Header from "./components/HeaderComponent";
import Inscription from "./pages/InscriptionPage";
import Recompenses from "./pages/RecompensesPage";
import Footer from "./components/FooterComponent";
import Parrainage from "./pages/Parrainage";
import UserAccount from "./auth/Users";
import Connexion from "./auth/Connexion";
import ChangeProfil from "./auth/ChangeProfilUser";
import ChangePassword from "./auth/ChangePassword";
import SupprimerCompte from "./auth/DeleteUser";
import Contact from "./pages/Contact";
import CharteModeration from "./pages/CharteModeration";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import CGU from "./pages/CGU";
import CGV from "./pages/CGV";
import AdminRoute from "./components/AdminRoute";
import AdminDashboard from "./components/AdminDashboard";
import Suggestions from "./components/Suggestions";
import AdminSuggestions from "./components/AdminSuggestions";
import MessagesAdmin from "./components/MessageAdmin";
import Guide from "./pages/Guide-mobile";

function App() {
  return (
    <>
      <Router>
        <Header />
        <Routes>

          {/* ── Pages principales ─────────────────────────────────────── */}
          <Route path="/"            element={<Home />} />
          <Route path="/inscription" element={<Inscription />} />
          <Route path="/recompenses" element={<Recompenses />} />
          <Route path="/contact"     element={<Contact />} />
          <Route path="/parrainage"  element={<Parrainage />} />
          <Route path="/guide"       element={<Guide />} />

          {/* ── Compte utilisateur ────────────────────────────────────── */}
          <Route path="/user"             element={<UserAccount />} />
          <Route path="/login"            element={<Connexion />} />
          <Route path="/changeProfil"     element={<ChangeProfil />} />
          <Route path="/changePassword"   element={<ChangePassword />} />
          <Route path="/supprimerCompte"  element={<SupprimerCompte />} />

          {/* ── Légal ─────────────────────────────────────────────────── */}
          <Route path="/charte-moderation" element={<CharteModeration />} />
          <Route path="/cgu"               element={<CGU />} />
          <Route path="/cgv"               element={<CGV />} />
          <Route path="/confidentialite"   element={<PolitiqueConfidentialite />} />

          {/* ── Suggestions pionniers ─────────────────────────────────── */}
          <Route path="/suggestions" element={<Suggestions />} />

          {/* ── Admin uniquement ──────────────────────────────────────── */}
          <Route path="/admin/dashboard" element={
            <AdminRoute><AdminDashboard /></AdminRoute>
          } />
          <Route path="/admin/messages" element={
            <AdminRoute><MessagesAdmin /></AdminRoute>
          } />
          <Route path="/admin/suggestions" element={
            <AdminRoute><AdminSuggestions /></AdminRoute>
          } />

        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;